import { InternalResourceConfig } from "./types";

const resourceRegistry = new Map<string, InternalResourceConfig>();

export function registerInternalResource(config: InternalResourceConfig): void {
  resourceRegistry.set(config.resourceName, config);
}

export function getAllInternalResources(): InternalResourceConfig[] {
  return Array.from(resourceRegistry.values());
}
